import {
  BarChart3,
  ClipboardCheck,
  CreditCard,
  Gauge,
  Lightbulb,
  Rss,
  Settings,
  Store,
  Users,
  type LucideIcon,
} from 'lucide-react';

export interface CommandPaletteNavItem {
  /** Schluessel im Namensraum `common`. */
  labelKey: string;
  path: string;
  icon: LucideIcon;
  shortcut?: string;
}

/**
 * Sprungziele der Befehlspalette.
 *
 * Als Datenliste ausgelagert, damit der Vertrag "wohin kann die Palette
 * springen" pruefbar ist, ohne cmdk und Radix in jsdom zu oeffnen. Die ersten
 * drei Eintraege sind dieselben Arbeitsbereiche wie in der Seitenleiste; es
 * gibt je Flaeche genau einen Namen und genau ein Ziel.
 */
export const COMMAND_PALETTE_NAVIGATION: CommandPaletteNavItem[] = [
  { labelKey: 'nav.feedCheck', path: '/', icon: Gauge },
  { labelKey: 'nav.workbench', path: '/workbench', icon: ClipboardCheck },
  { labelKey: 'nav.performance', path: '/performance', icon: BarChart3 },
  { labelKey: 'nav.roadmap', path: '/roadmap', icon: Lightbulb },
  { labelKey: 'nav.plansAndPricing', path: '/pricing', icon: CreditCard },
  { labelKey: 'nav.settings', path: '/settings', icon: Settings, shortcut: ',' },
  { labelKey: 'nav.googleAccounts', path: '/settings?tab=accounts', icon: Users },
  { labelKey: 'nav.merchantCenters', path: '/settings?tab=merchants', icon: Store },
  { labelKey: 'nav.feeds', path: '/settings?tab=feeds', icon: Rss },
];

/**
 * Anzeige eines Kuerzels (A3-16): die Palette zeigte bei "Einstellungen" nur
 * ",". Dieselbe Plattformregel wie `KeyboardShortcutsDialog.tsx`.
 */
export function formatShortcut(key: string, platform: string = typeof navigator === 'undefined' ? '' : navigator.platform): string {
  return /Mac|iPhone|iPad|iPod/.test(platform) ? `⌘${key}` : `Ctrl+${key}`;
}
